/*****
 * Created with WebStorm.
 * Date : 2019/5/31.
 * Author : Ztr.
 * Func : ...
 ******/
import $https from '@/utils/https'
import Cookies from 'js-cookie';

//问诊订单接口
export function getConsultList (params,pageParam) {
    return $https({
        url: '/api/consult/getConsultList',
        method: 'POST',
        //serviceId: 'api.login',
        param: params,
        pageParam: pageParam,
    })
}

//获取IM信息
export function getImUser (params) {
    return $https({
        url: '/api/user/detail',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}

//获取问诊详细信息
export function getConsultInfoByOrderNo (params) {
    return $https({
        url: '/api/consult/getConsultInfoByOrderNo',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}

//获取患者问诊信息
export function getDoctorConsultInfo (params) {
    return $https({
        url: '/api/consult/getDoctorConsultInfo',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}

//获取平台问诊聊天其他功能列表
export function getPlatImResourceList (params) {
    return $https({
        url: '/api/consult/getPlatImResourceList',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}

//获取候诊队列信息
export function getInitiateConsultInfo (params) {
    return $https({
        url: '/api/consult/getInitiateConsultInfo',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}


//发送指令
export function sendInstructions (params) {
    return $https({
        url: '/api/consult/sendInstructionsMsg',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}

//重新下单
export function againOrder (params) {
    return $https({
        url: '/api/consult/againOrder',
        method: 'POST',
        //serviceId: 'api.login',
        param: params
    })
}



// WEBPACK FOOTER //
// ./src/services/modules/IM.js